export default "__VITE_ASSET__DC8kI5xk__"